const TextContainer = ({ label, content, isHTML, isTextArea }) => {
  let newText = "";
  if (isTextArea) {
    if (content) {
      newText = content.split("\n").map((line, index) => (
        <p key={index} className="pb-1">
          {line}
        </p>
      ));
    }
  }

  return (
    <div className="w-full flex-1 text-text-1/85">
      {isHTML ? (
        <div className=" flex flex-col items-start justify-start py-2 text-text-1 mt-2">
          <h5 className="px-1 font-semibold text-text-1/85">{label}</h5>
          <div className="text-text-1/85 text-base">
            <div dangerouslySetInnerHTML={{ __html: content }} />
          </div>
        </div>
      ) : (
        <div>
          {isTextArea ? (
            <div className=" flex flex-col items-start justify-start py-2 mt-2">
              <h5 className=" font-semibold text-nowrap text-text-1/85">
                {label}
              </h5>
              <div>
                <div>{newText}</div>
              </div>
            </div>
          ) : (
            <>
              <p className="summary-p">
                <span className="text-nowrap">{label}</span>:
                <span className="summary-span">{content || "N/A"}</span>
              </p>
            </>
          )}
        </div>
      )}
    </div>
  );
};

export default TextContainer;
